enum BlogsStatic {
  /**
   * @member {string}
   * @method post
   * @version 1.0
   * @description get latest blog posts request.
   */
  getLatestBlogPosts = "/v2/lastest-blog-posts",
}

const BlogsDynamic = {
  /**
   * @member {string}
   * @method GET
   * @version 1.0
   * @description get latest blog posts request.
   */
  getLatestBlogPosts: () => ``,
};

export const BlogsEndpoints = {
  ...BlogsDynamic,
  ...BlogsStatic,
};

export type BlogsEndpoints = typeof BlogsEndpoints;
